import AdminPayoutsPage from '../../../components/admin/payouts/AdminPayoutsPage'

export default function Payouts() {
  return <AdminPayoutsPage />
}
